import React from "react";
import { Link, useParams } from "react-router-dom";
import { Box, Button, Grid2, Stack, Typography } from "@mui/material";
import { useGetBranchesByCompanyIdQuery } from "../../../api/branchApi";
import { BranchListViewPresentational } from "./branchListView";
import { LoadingIndicator } from "../../shared/alerts/loadingIndicator";
import { useAuthenticatedUser } from "../../../hooks/useAuthenticatedUser";
import { Add } from "@mui/icons-material";
import { Collection } from "../../../enums/collections.enum";

export const BranchListContainer: React.FC = () => {
  const { companyId } = useParams<{ companyId?: string }>();
  const { data: branches = [], isLoading, error } = useGetBranchesByCompanyIdQuery(companyId ?? "");

  const { currentUserIsOwnerOf } = useAuthenticatedUser();
  
  // Handle loading state
  if (isLoading) {
    return <LoadingIndicator message="Loading branches..." />;
  }

  // Handle error state
  if (error) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", marginTop: 4 }}>
        <Typography color="error">Error: {error.toString()}</Typography>
      </Box>
    );
  }

  return (
    <>
     {currentUserIsOwnerOf(companyId) && <Stack direction="row" justifyContent="space-between" alignItems="center" mr={2}>
        <Typography variant="h5" fontWeight={600}>

        </Typography>
        <Grid2>
          
          <Button
            variant="contained"
            startIcon={<Add />}
            component={Link}
            to={`/${Collection.Companies}/${companyId}/${Collection.Branches}/add`}
          >
            Add Branch
          </Button>
        </Grid2>
      </Stack>}
      <BranchListViewPresentational
      companyId={companyId ?? ''}
      branches={branches}
    />
    </>
  
  );
};

